<p-toast key="logs-error" position="top-right"></p-toast>

<p-sidebar [style]="{width: '90%'}" [(visible)]="onWhereClause" [blockScroll]="true" [modal]="true"
           [position]="'right'">
    <div>
        <h5 class="p-m-0 p-text-primary">LogType Meta Data</h5>
    </div>
    <div class="p-mt-5">
        <p-tabView>
            <p-tabPanel [header]="tabHeader?.name" *ngFor="let tabHeader of logTypes">


                <div class="p-text-bold p-text-secondary divider-bottom p-py-2">
                    Column Fields
                </div>

                <div class="p-py-2" *ngFor="let field of tabHeader?.columnFields">
                    <div class="p-text-secondary">
                        {{field}}
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</p-sidebar>


<div class="p-mt-4">

    <div class="sticky-filter divider-bottom" [formGroup]="logsFilterForm">

        <div class="p-grid p-ai-center">
            <div class="p-col-6 p-lg-3 p-xl-2">
                <div class="p-field">
                    <label>From Date*</label>
                    <p-calendar [baseZIndex]="100" [readonlyInput]="true" [monthNavigator]="true"
                                showButtonBar="true"
                                clearButtonStyleClass="p-d-none"
                                styleClass="width-100" dateFormat="dd-M-yy" [showTime]="true"
                                formControlName="fromDateTime"
                                [showIcon]="true"></p-calendar>
                </div>
            </div>
            <div class="p-col-6 p-lg-3 p-xl-2">
                <div class="p-field">
                    <label>To Date*</label>
                    <p-calendar [baseZIndex]="100" [readonlyInput]="true" [monthNavigator]="true"
                                showButtonBar="true"
                                clearButtonStyleClass="p-d-none"
                                styleClass="width-100" dateFormat="dd-M-yy" [showTime]="true"
                                formControlName="toDateTime"
                                [showIcon]="true"></p-calendar>
                </div>
            </div>
            <div class="p-col-6 p-lg-3 p-xl-2">
                <div class="p-field">
                    <label>LogType</label>
                    <p-dropdown
                            (onChange)="logsFilterForm?.controls?.additionalWhereClause?.setValue(null); dataLogs = null"
                            appendTo="body" placeholder="Select.." styleClass="width-100" [options]="logTypes"
                            formControlName="logType"
                            [emptyMessage]="'No LogType Found'" filterBy="name"
                            emptyFilterMessage="No LogType Found"></p-dropdown>
                </div>
            </div>
            <div class="p-col-4 p-d-none p-d-xl-block">

            </div>
            <div class="p-col-6 p-lg-3 p-text-right p-xl-2 p-pr-3">
                <button pButton pRipple (click)="onExecuteLogsFilter()" label="Execute"
                        class="p-button-secondary"></button>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12 p-md-6 p-xl-4">
                <div class="p-field">
                    <label>Filter Clause</label>
                    <textarea formControlName="additionalWhereClause" [rows]="7" class="width-100" pInputTextarea
                              autoResize="autoResize"></textarea>
                </div>
            </div>
            <!--            <div class="p-col">-->
            <!--                <div>{{'&nbsp;'}}</div>-->
            <!--                <i (click)="onWhereClause = true" class="p-pt-2 pi pi-info-circle p-text-secondary p-cursor"-->
            <!--                   pRipple></i>-->
            <!--            </div>-->
        </div>

    </div>


    <div class="p-mt-5" *ngIf="isLoading">
        <div class="p-mt-5 p-text-center">
            <div>
                <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 1.25rem"></i>
            </div>
            <div>
                Loading Logs..
            </div>
        </div>
    </div>

    <div class="p-mt-5" *ngIf="(dataLogs?.length === 0 && !isLoading) || isError">
        <div class="p-mt-5 p-text-center">
            <div>
                <h5 class="p-m-0 p-text-secondary"> No Logs Available</h5>
            </div>
        </div>
    </div>

    <div class="p-mt-3">

    <div class="card p-text-secondary p-mx-2 p-shadow-4" *ngFor="let logs of dataLogs">
        <div class="p-grid">
            <div class="p-col-12" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                <div *ngFor="let log of logs">
                    <div class="p-grid p-ai-start">
                        <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" class="p-col-4 p-md-2">
                            <div class="p-text-primary">{{log?.field}}</div>
                        </div>
                        <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" class="p-col-8 p-md-10">
                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{log?.value ? log?.value : '-'}}</div>
                        </div>
                    </div>

                </div>
                <!--                <pre style="white-space: pre-wrap">{{log ? (log | json) : '-'}}</pre>-->
            </div>
        </div>
    </div>
    </div>
</div>